module.exports = __webpack_public_path__ + "assets/exit-fullscreen.c0a0b5af.svg";